<template>
  <div class="skeleton" />
</template>

<script setup lang="ts"></script>
